module.exports = __webpack_public_path__ + "static/media/roleManagement.e8871384.svg";